import { SearchState } from ".";
import {
  CurrentLocation,
  SearchDisplayText,
  SearchParameters,
} from "../../interfaces";

type SearchActionType =
  | {
      type: "[Search] - SetParameters";
      payload: SearchParameters;
    }
  | {
      type: "[Search] - setSearchDisplayText";
      payload: SearchDisplayText;
    }
  | {
      type: "[Search] - setCurrentLocation";
      payload: CurrentLocation;
    }
  | {
      type: "[Search] - setComponentLocationRender";
      payload: boolean;
    };

export const searchReducer = (
  state: SearchState,
  action: SearchActionType
): SearchState => {
  switch (action.type) {
    case "[Search] - SetParameters":
      const existingIndex = state.searchParametersHistory.findIndex(
        (parameters) => parameters.countryId === action.payload.countryId
      );

      let updatedHistory;
      if (existingIndex !== -1) {
        // Si los parámetros ya existen en el historial, actualizamos los valores
        const updatedParameters = {
          ...state.searchParametersHistory[existingIndex],
          ...action.payload,
        };
        updatedHistory = [
          ...state.searchParametersHistory.slice(0, existingIndex),
          updatedParameters,
          ...state.searchParametersHistory.slice(existingIndex + 1),
        ];
      } else {
        // Si los parámetros no existen en el historial, los agregamos al principio
        const newParameters = { ...action.payload };
        updatedHistory = [newParameters, ...state.searchParametersHistory];
      }

      const searchTimes = state.searchCounter + 1;

      return {
        ...state,
        searchParameters: action.payload,
        searchParametersHistory: updatedHistory,
        searchCounter: searchTimes,
        isLoading: false,
        componentLocationRender: true,
      };

    case "[Search] - setSearchDisplayText":
      return {
        ...state,
        searchDisplayText: action.payload,
      };
    case "[Search] - setCurrentLocation":
      return {
        ...state,
        currentLocation: action.payload,
      };
    case "[Search] - setComponentLocationRender":
      return {
        ...state,
        componentLocationRender: action.payload,
      };

    default:
      return state;
  }
};
